import React from 'react';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import StylishNewInput from '../DesignSystems/New/StylishNewInput';
import { Row } from 'react-bootstrap';

interface ChecklistItem {
  label: string;
  checked: boolean;
}

interface ICSChecklistProps {
  checklist?: ChecklistItem[];
  setChecklist: (checklist: ChecklistItem[]) => void;
  editable?: boolean;
  existingData?: boolean;
}

export default function ICSChecklist({
  checklist = [],
  setChecklist,
  editable = false,
  existingData = false,
}: ICSChecklistProps) {
  const handleLabelChange = (index: number, newLabel: string) => {
    const updatedChecklist = checklist.map((item, idx) =>
      idx === index ? { ...item, label: newLabel } : item
    );
    setChecklist(updatedChecklist);
  };

  const handleCheckedChange = (index: number, checked: boolean) => {
    const updatedChecklist = checklist.map((item, idx) =>
      idx === index ? { ...item, checked } : item
    );
    setChecklist(updatedChecklist);
  };

  const addItem = () => {
    setChecklist([...checklist, { label: '', checked: false }]);
  };

  const removeItem = (index: number) => {
    setChecklist(checklist.filter((_, idx) => idx !== index));
  };

  return (
    <div className="ICSChecklist">
      <h6 className="mb-2">Checklist</h6>
      {checklist.map((item, index) => (
        <div key={index} className="checklist-item">
          {editable ? (
            <Row className="mb-2">
              <div className="col-6">
                <StylishNewInput
                  type="text"
                  value={item.label}
                  onChange={(e) => handleLabelChange(index, e.target.value)}
                  placeholder="Enter item label"
                />
              </div>
              <div className="col-1">
                <StylishNewButton
                  type="button"
                  className="button button--tertiary"
                  onClick={() => removeItem(index)}
                >
                  Remove
                </StylishNewButton>
              </div>
            </Row>
          ) : (
            <div className="d-flex align-items-center mb-2">
              <input
                type="checkbox"
                id={`checklist-item-${index}`}
                checked={item.checked || false}
                onChange={(e) => handleCheckedChange(index, e.target.checked)}
                disabled={!existingData}
                className="me-2"
              />
              <label
                htmlFor={`checklist-item-${index}`}
                className="checklist-label mb-0"
              >
                {item.label}
              </label>
            </div>
          )}
        </div>
      ))}
      {editable && (
        <StylishNewButton
          type="button"
          onClick={addItem}
          className="button--primary"
        >
          Add Item
        </StylishNewButton>
      )}
    </div>
  );
}
